var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonDownloadIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.6667V13.7333C18 15.2268 18 15.9735 17.7094 16.544C17.4537 17.0457 17.0457 17.4537 16.544 17.7094C15.9735 18 15.2268 18 13.7333 18H6.26667C4.77319 18 4.02646 18 3.45603 17.7094C2.95426 17.4537 2.54631 17.0457 2.29065 16.544C2 15.9735 2 15.2268 2 13.7333V12.6667M14.4444 8.22222L10 12.6667M10 12.6667L5.55556 8.22222M10 12.6667V2",
    stroke: "#1A0242",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDownloadIconHover);
export default __webpack_public_path__ + "static/media/button-download-icon-hover.9ee61a676310c45492efdbce8915e735.svg";
export { ForwardRef as ReactComponent };